export default "__VITE_ASSET__44660556__"